import { render, staticRenderFns } from "./transactionPowerballDetail.vue?vue&type=template&id=31f2b498&scoped=true&"
import script from "./transactionPowerballDetail.vue?vue&type=script&lang=js&"
export * from "./transactionPowerballDetail.vue?vue&type=script&lang=js&"
import style0 from "./transactionPowerballDetail.vue?vue&type=style&index=0&id=31f2b498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f2b498",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VDataTable,VImg,VRow})
